import request from '@/utils/request'
// 申请拼货资格
export function assembleApply(data) {
  return request({
    url: '/spell/mcht/apply',
    method: 'put',
    data
  })
}
// 拼团商品列表
export function assembleGoodsList(params) {
  return request({
    url: '/spell/goods/list',
    method: 'get',
    params
  })
}
// 删除拼货商品
export function deleteAssembleGoods(params) {
  return request({
    url: '/spell/goods/del',
    method: 'delete',
    params
  })
}
// 添加拼货商品
export function addAssembleGoods(data) {
  return request({
    url: '/spell/goods/add',
    method: 'put',
    data
  })
}
// 拼货商品详情
export function assembleGoodsDetail(params) {
  return request({
    url: '/spell/goods/detail',
    method: 'get',
    params
  })
}
// 修改拼货详情
export function editAssembleDetail(data) {
  return request({
    url: '/spell/goods/updateSpellGoods',
    method: 'post',
    data
  })
}
// 拼货商品订单
export function assembleGoodsOrder(params) {
  return request({
    url: '/spell/order/getPageListBySpellGoodsItemId',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/assemble.js